// src/App.js
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import RefundForm from "./views/pages/RefundForm";
import Home from "./views/pages/Home"; // Optional home page if needed
import ByCities from "./views/pages/ByCities";
import BoothDetail from "./views/pages/BoothDetail";
import "./index.css"; // or './App.css'
import RefundSuccess from "./views/pages/RefundSuccess";
import RouteChangeTracker from "./utils/RouteChangeTracker";
import LocationList from "./views/pages/LocationsList";

function App() {
  return (
    <Router basename="/">
      <RouteChangeTracker />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/refund" element={<RefundForm />} />
        <Route path="/refund/success" element={<RefundSuccess />} />
        <Route path="/locations" element={<LocationList />} />

        <Route path="/cities/:cityID" element={<ByCities />} />
        <Route path="/booth/:boothID" element={<BoothDetail />} />
      </Routes>
    </Router>
  );
}

export default App;
